import apiService from '../api';

const surveyApiStudentMixin = {
  async getStudentAssignments() {
    return apiService.request('/surveys/student/assignments');
  },

  async getStudentAssignmentDetails(assignmentId) {
    return apiService.request(`/surveys/student/assignments/${assignmentId}`);
  },

  async submitSurveyResponses(assignmentId, responses) {
    return apiService.request(`/surveys/student/assignments/${assignmentId}/responses`, {
      method: 'POST',
      body: JSON.stringify({ responses })
    });
  },

  /** Resolves a "class link" (posted in a group chat) to the logged-in student's own assignment. */
  async resolveSurveyClassLink(token) {
    return apiService.request(`/surveys/student/class/${token}/my-assignment`);
  },
};

export default surveyApiStudentMixin;
